import { Fade } from 'react-awesome-reveal'
import { useTranslation } from 'next-i18next'

import { css } from '@emotion/react'
import html from 'html-react-parser'

import CustomReveal from '@/components/common/CustomReveal'
import { spacingSection, blueBox } from '@/styles/mixins'
import { mediaUp } from '@/styles/media'
import { H3Styles, Text1Styles } from '@/styles/typography'
import { Grid, mediaColumns } from '@/styles/grid'
import Title from '@/components/common/Title'

import ButtonDownload from '@/components/common/ButtonDownload'

function MoreSection() {
  const { t } = useTranslation('landing')

  return (
    <section css={container} id="more-section">
      <CustomReveal>
        <Grid>
          <div css={titlesWrapper}>
            <Title text={t('saudiExpo.more.title')} css={title} />
            <div css={description}>{t('saudiExpo.more.description')}</div>
          </div>
        </Grid>
      </CustomReveal>
      <Fade>
        <Grid>
          <div css={[column, columnLeft]}>
            <div css={imageWrapper}>
              <img
                src={
                  'https://cdn.naviparking.com/digital_parking/img/saudiExpo-brochure1.webp'
                }
              />
            </div>
            {html(t('saudiExpo.more.booklet1'))}
            <ButtonDownload
              href={
                'https://cdn.naviparking.com/digital_parking/terms_and_conditions/expo_naviparking_general-brochure.pdf'
              }
              text={t('saudiExpo.more.booklet.downloadPdf')}
            />
          </div>
          <div css={[column, columnRight]}>
            <div css={imageWrapper}>
              <img
                src={
                  'https://cdn.naviparking.com/digital_parking/img/saudiExpo-brochure2.webp'
                }
              />
            </div>
            {html(t('saudiExpo.more.booklet2'))}
            <ButtonDownload
              href={
                'https://cdn.naviparking.com/digital_parking/terms_and_conditions/expo_naviparking_brochure_package.zip'
              }
              text={t('saudiExpo.more.booklet.downloadZip')}
            />
          </div>
        </Grid>
      </Fade>
    </section>
  )
}

const container = css`
  ${spacingSection};
`

const title = css`
  margin-bottom: 40px;

  ${mediaUp('lg')} {
    margin-bottom: 80px;
  }
`

const description = css`
  ${Text1Styles};
  margin: 0 0 20px;
  text-align: center;

  ${mediaUp('lg')} {
    margin: -40px 0 40px;
  }
`

const titlesWrapper = css`
  ${mediaColumns({ xs: [10, 1], md: [6, 3] })};
`

const column = css`
  ${blueBox};
  ${H3Styles};
  padding: 28px 20px;
  text-align: center;

  ${mediaUp('lg')} {
    padding: 40px 40px 60px;
  }
`

const columnLeft = css`
  ${mediaColumns({ xs: [10, 1], md: [5, 1] })};
  margin-bottom: 18px;

  ${mediaUp('md')} {
    margin-bottom: 0;
  }
`

const columnRight = css`
  ${mediaColumns({ xs: [10, 1], md: [5, 6] })};
`

const imageWrapper = css`
  position: relative;
  max-width: 100%;
  max-height: 100%;
  width: 160px;
  height: 116px;
  margin-bottom: 18px;

  ${mediaUp('lg')} {
    width: 360px;
    height: 260px;
    margin-bottom: 30px;
  }

  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`

export default MoreSection
